// Color utilities for SortLab

const lightPalette = {
  background: '#F6F8FB',
  surface: '#FFFFFF',
  border: '#D8E0EA',
  text: '#182235',
  textSecondary: '#5C6B80',
  primary: '#2563EB',
  success: '#15803D',
  warning: '#B45309',
  error: '#DC2626',
  info: '#0891B2'
};

export const Colors = {
  light: lightPalette,

  status: {
    idle: '#64748B',
    comparing: '#B45309',
    swapping: '#DC2626',
    selected: '#2563EB',
    pivot: '#7C3AED',
    sorted: '#15803D',
    merging: '#0891B2',
    bucket: '#0E7490',
    heap: '#BE185D',
    run: '#D97706',
    gap: '#4F46E5'
  }
};

export const Theme = {
  isDark: false,
  colors: Colors.light
};

export const getStatusColor = (status: string): string => {
  return Colors.status[status as keyof typeof Colors.status] || Colors.status.idle;
};
